/**
 * Firebase Config Decoder
 */

function deriveKey(): string {
  const appName = "kpi-dashboard";
  const salt = "firebase-config-obfuscation";
  
  const combined = appName + salt;
  let hash = 0;
  for (let i = 0; i < combined.length; i++) {
    const char = combined.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  
  return Math.abs(hash).toString(16).padStart(16, '0');
}

function xorCipher(data: string, key: string): string {
  const keyChars = key.split('');
  return data
    .split('')
    .map((char, index) => {
      const keyChar = keyChars[index % keyChars.length];
      const charCode = char.charCodeAt(0);
      const keyCode = keyChar.charCodeAt(0);
      const encrypted = charCode ^ keyCode;
      return String.fromCharCode(encrypted);
    })
    .join('');
}

function substituteChars(data: string, reverse: boolean = false): string {
  const map: { [key: string]: string } = {
    'a': 'q', 'b': 'w', 'c': 'e', 'd': 'r', 'e': 't',
    'f': 'y', 'g': 'u', 'h': 'i', 'i': 'o', 'j': 'p',
    'k': 'a', 'l': 's', 'm': 'd', 'n': 'f', 'o': 'g',
    'p': 'h', 'q': 'j', 'r': 'k', 's': 'l', 't': 'z',
    'u': 'x', 'v': 'c', 'w': 'v', 'x': 'b', 'y': 'n',
    'z': 'm'
  };
  
  const reverseMap: { [key: string]: string } = {};
  Object.keys(map).forEach(key => {
    reverseMap[map[key]] = key;
  });
  
  const activeMap = reverse ? reverseMap : map;
  
  return data.split('').map(char => {
    const lower = char.toLowerCase();
    if (activeMap[lower]) {
      return char === char.toUpperCase() && char !== char.toLowerCase()
        ? activeMap[lower].toUpperCase()
        : activeMap[lower];
    }
    return char;
  }).join('');
}

function fromHex(hex: string): string {
  let result = '';
  for (let i = 0; i < hex.length; i += 2) {
    result += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return result;
}

function base64Decode(base64: string): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
  const str = base64.replace(/=+$/, '');
  let output = '';

  for (let i = 0; i < str.length;) {
    const c1 = str.charAt(i++);
    const c2 = str.charAt(i++);
    const c3 = str.charAt(i++);
    const c4 = str.charAt(i++);

    const enc1 = c1 ? chars.indexOf(c1) : -1;
    const enc2 = c2 ? chars.indexOf(c2) : -1;
    const enc3 = c3 ? chars.indexOf(c3) : -1;
    const enc4 = c4 ? chars.indexOf(c4) : -1;

    if (enc1 === -1 || enc2 === -1) continue;

    const chr1 = (enc1 << 2) | (enc2 >> 4);
    output += String.fromCharCode(chr1);

    if (enc3 !== -1) {
      const chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
      output += String.fromCharCode(chr2);
    }

    if (enc4 !== -1) {
      const chr3 = ((enc3 & 3) << 6) | enc4;
      output += String.fromCharCode(chr3);
    }
  }

  return output;
}

export function decodeConfig(obfuscated: string): string {
  try {
    const fromHexDecoded = fromHex(obfuscated);
    const unsubstituted = substituteChars(fromHexDecoded, true);
    const key = deriveKey();
    const xorDecoded = xorCipher(unsubstituted, key);
    return base64Decode(xorDecoded);
  } catch (error) {
    console.error('Failed to decode Firebase config:', error);
    throw new Error('Invalid Firebase configuration');
  }
}
